import './index.css'

const NotFound = () => (
  <div className="home-container not-found-container">
    <h1 className="not-found">Page Not Found !!</h1>
  </div>
)

export default NotFound
